// We're using mstage userkit as a tool for composing and sending tracking trigger events to our event-tracking-service
const tracker = require('./mstage-user-kit')(window || {})

const impression = require('./impression')
const globalProperties = require('./global-properties')
const {clickProperties} = require('../events/click')
const {pageviewProperties} = require('../events/pageview')
const {customizedEventProperties} = require('../events/customized')
const checkingChannel = require('./checking-channel')

let initTrackerTimer = null
window.TRACKING_QUEUE = []

tracker.doTrack = function (eventName, properties, callback) {
  if (!tracker.isTrackerReady()) {
    window.TRACKING_QUEUE.push({
      eventName,
      properties,
      callback,
    })
  } else {
    tracker.track(eventName, properties, callback)
  }
}

tracker.scanTrackQueue = function () {
  window.TRACKING_QUEUE.forEach(({eventName, properties, callback}) => {
    tracker.track(eventName, properties, callback)
  })
  window.TRACKING_QUEUE = []
}

impression.init(tracker)
tracker.registerImpression = function (
  evtName = 'Web.Impression.Content',
  properties,
) {
  impression.register(
    evtName,
    impressionProperties(properties, globalProperties()),
    tracker,
  )
}

tracker.global = function showGlobalConfig() {
  // eslint-disable-next-line no-console
  console.info('global properties -> ', globalProperties())
}

tracker.click = function click(properties, evtName = 'click.body', callback) {
  tracker.doTrack(
    evtName,
    clickProperties(properties, globalProperties()),
    callback,
  )
}

tracker.pageview = function pageview(properties, evtName = 'Web.View.Screen') {
  tracker.doTrack(evtName, pageviewProperties(properties, globalProperties()))
}

tracker.event = function customEvent(properties, evtName, callback) {
  if (!evtName) {
    console.error('Event name is mandatory in trigger event method!!')
    return
  }
  tracker.doTrack(
    evtName,
    customizedEventProperties(properties, globalProperties()),
    callback,
  )
}

// execute eventTrackerAsyncInit function from browser
function asyncTrackerInit() {
  tracker.init({
    eventTrackingUrl: 'https://tracking.shopback.com/',
  })
  window &&
    window.eventTrackerAsyncInit &&
    window.eventTrackerAsyncInit(tracker)
  checkingChannel.runTracker(tracker)
  checkingChannel.exposeTracker(tracker, window)
  tracker.scanTrackQueue && tracker.scanTrackQueue()
}

function executeAsyncInit() {
  // this 50 ms is for SB extension to set neccessary properties
  if (document.readyState === 'complete') {
    clearTimeout(initTrackerTimer)
    initTrackerTimer = setTimeout(asyncTrackerInit, 50)
  } else {
    document.addEventListener('readystatechange', () => {
      if (document.readyState === 'complete') {
        clearTimeout(initTrackerTimer)
        initTrackerTimer = setTimeout(asyncTrackerInit, 50)
      }
    })
  }
}

executeAsyncInit()

module.exports = tracker
